import { DropdownItem } from "../../Interfaces/dropdownInterfaces";

interface IProps {
  options: DropdownItem[];
  value: string | number;
  name: string;
  onChange: (name: string, value: any) => void;
  label: string;
  hideSelectAll?: boolean;
  hideLabel?: boolean;
}

const SelectableButtons = ({
  label,
  name,
  onChange,
  options,
  value,
  hideSelectAll,
  hideLabel,
}: IProps) => {
  const clickHandler = (id: string | number | null) => {
    if (value === id) onChange(name, null);
    else onChange(name, id);
  };

  return (
    <div className="flex flex-col justify-start items-start w-full gap-1">
      {hideLabel ? <></> : <div className="text-xs">{label}</div>}
      <div className="w-full overflow-x-auto flex flex-row justify-start items-center gap-3">
        {!hideSelectAll ? (
          <div
            className={`py-2 px-3 whitespace-nowrap rounded text-xs transition-all duration-200 border border-sky-600 select-none cursor-pointer ${
              !value ? "bg-sky-600 text-white" : "bg-white text-sky-600"
            }`}
            onClick={() => clickHandler(null)}
          >
            همه
          </div>
        ) : (
          <></>
        )}
        {options && options.length ? (
          options.map((o) => (
            <div
              key={o.id}
              className={`py-2 px-3 whitespace-nowrap rounded text-xs transition-all duration-200 border border-sky-600 select-none cursor-pointer ${
                value && value === o.id
                  ? "bg-sky-600 text-white"
                  : "bg-white text-sky-600"
              }`}
              onClick={() => clickHandler(o.id)}
            >
              {o.name}
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default SelectableButtons;
